// extracted by css-extract-rspack-plugin
export default {"empty-state":"GFehmK","emptyState":"GFehmK"};